import React from 'react';
import { Button } from './ui/button';
import { Upload, Sparkles, ArrowRight } from 'lucide-react';
import { Badge } from './ui/badge';

export const HeroSection = ({ onUploadClick }) => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 gradient-hero"></div>
      <div className="absolute top-20 right-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-accent/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Badge */}
          {/*
          <div className="flex justify-center mb-8 animate-float">
            <Badge className="bg-primary/10 text-primary border-primary/20 px-4 py-2 text-sm font-medium">
              <Sparkles className="w-4 h-4 mr-2" />
              Intelligence-Powered Code Generation
            </Badge>
          </div>
        */}
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center text-foreground leading-tight mb-6">
            Transform SQL Scripts into
            <span className="block mt-2">
              <span className="bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
                Clean Architecture APIs
              </span>
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-center text-muted-foreground max-w-3xl mx-auto mb-12 leading-relaxed">
            Upload your SQL database scripts and instantly receive production-ready .NET APIs
            following Clean Architecture principles. Save weeks of development time.
          </p>

          {/* CTA Button - Slightly Left of Center */}
          <div className="flex justify-center">
            <div className="flex flex-col sm:flex-row gap-4 items-center" style={{ marginLeft: '-2rem' }}>
              <Button
                onClick={onUploadClick}
                size="lg"
                className="group bg-primary hover:bg-primary-dark text-primary-foreground font-semibold px-8 py-6 text-lg shadow-xl hover:shadow-2xl transition-all hover:scale-105"
              >
                <Upload className="w-5 h-5 mr-2 group-hover:animate-bounce" />
                Upload SQL Script
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              {/*...  <Button 
                variant="outline"
                size="lg"
                className="border-2 border-primary text-primary hover:bg-primary/5 font-semibold px-8 py-6 text-lg"
                onClick={() => document.getElementById('video')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Watch Demo
              </Button>*/}
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-20 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-primary mb-2">1000x</div>
              <div className="text-sm text-muted-foreground">Faster Development</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary mb-2">100%</div>
              <div className="text-sm text-muted-foreground">Clean Architecture</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary mb-2">5 sec</div>
              <div className="text-sm text-muted-foreground">Generation Time</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
